import { useSelector } from 'react-redux';
import { jwtDecode } from 'jwt-decode';
// redux
import { selectUser, selectToken, selectIsLoggedIn, selectIsRefreshing, } from 'redux/auth/authSelectors';
// helpers
import { compareStrings } from 'helpers';

const useAuth = () => {
  const token = useSelector(selectToken);
  const user = useSelector(selectUser);
  let isSuperAdmin = false;
  let isAdmin = false;

  if (token) {
    const decoded = jwtDecode(token);
    const { role } = decoded?.userInfo ?? {};
    isSuperAdmin = compareStrings(role, 'superadmin');
    isAdmin = compareStrings(role, 'admin');
  }

  let authState = {
    isLoggedIn: useSelector(selectIsLoggedIn),
    isRefreshing: useSelector(selectIsRefreshing),
    isSuperAdmin,
    isAdmin,
    user,
  };

  return authState;
};

export default useAuth;
